import ScrollReveal from '@/components/ui/ScrollReveal'

interface ProjectChallengeProps {
  challenge: string
  sectionNumber?: string
}

export default function ProjectChallenge({ challenge, sectionNumber }: ProjectChallengeProps) {
  return (
    <ScrollReveal>
      <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-8 md:gap-12">
        <div>
          {sectionNumber && (
            <span className="text-label text-accent block mb-1">{sectionNumber}</span>
          )}
          <span className="text-label uppercase tracking-widest text-text-muted">
            The Challenge
          </span>
        </div>
        <p className="text-body text-text-secondary leading-relaxed">{challenge}</p>
      </div>
    </ScrollReveal>
  )
}
